import { useMemo } from 'react';
import { useLocation } from 'react-router';
import { useMultiLayerDrawerContext } from '../../modules/taboola-common-frontend-modules/multi-layer-drawer/components/MultiLayerDrawerProvider/MultiLayerDrawerProvider';
import { useModuleName } from '../useModuleName';

export const useModulePage = routes => {
    const { modulePages, moduleProviders } = useMultiLayerDrawerContext();
    const module = useModuleName();
    const { pathname } = useLocation();

    const { modulePage, route, path } = useMemo(
        () => ({
            modulePage: modulePages[`/${module}`]?.component,
            route: routes[module],
            path: pathname,
            provider: moduleProviders[module]?.provider,
        }),
        [module, pathname, routes, modulePages, moduleProviders]
    );

    return { modulePage, route, path };
};
